import PropTypes from 'prop-types'
import React from 'react'
import LearningPathSummary from '../../LearningPaths/LearningPathSummary'
import { LearningPathSummaryPropTypes } from '../../LearningPaths/LearningPathSummary'
import './styles.css'

function RecentPathways({ pathways = { results: [] }, loadMore = () => {} }) {
  return (
    <section id="recent-pathways" className="wrapper">
      <h3 className="title">My Pathways</h3>
      <div className="pathways-list">
        {pathways.results.map((path) => (
          <LearningPathSummary
            key={path.id}
            {...path}
          />
        ))}
      </div>
      {pathways.next && (
        <div className="load-more-pathways">
          <button type="button" onClick={() => loadMore()} className="load-more">Load More Pathways</button>
        </div>
      )}
    </section>
  )
}

RecentPathways.propTypes = {
  pathways: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape(LearningPathSummaryPropTypes)),
    count: PropTypes.number,
    next: PropTypes.string,
    prev: PropTypes.string
  }),
  loadMore: PropTypes.func
}

export default RecentPathways
